


























import {Component, Vue, Watch, Prop} from 'vue-property-decorator';
import {debounce} from 'lodash';

@Component
export default class CustomCard extends Vue {
  @Prop() conditions: any;
  @Prop() title: string;
  @Prop() name: string;
  @Prop({default: []}) getItem: any;

  check: any = [];
  includeUnknown: boolean = false;

  values: string = '';
  predicate: string = 'EQUALS';

  mounted() {
    if (this.conditions[this.name]) {
      let empty = this.conditions[this.name].values.find((e: string) => e === '');
      if (empty === '') {
        this.includeUnknown = true;
      }

      this.values = this.conditions[this.name].values
        ? this.conditions[this.name].values.filter((v: any) => !!v).join('\n')
        : '';

      this.predicate = this.conditions[this.name].predicate || this.predicate;
    } else {
      this.$set(this.conditions, this.name, {
        predicate: this.predicate,
        values: ['']
      });
    }
  }

  @Watch('predicate')
  onPredicateChanged(value: string, oldValue: string) {
    this.$set(this.conditions[this.name], 'predicate', value);
  }

  @Watch('values')
  onValueChanged() {
    this.updateConditionDebounced();
  }

  @Watch('includeUnknown')
  onIncludeUnknownChanged() {
    this.updateConditionDebounced();
  }

  get updateConditionDebounced() {
    return debounce(this.updateCondition, 100);
  }

  updateCondition() {
    if (this.values) {
      if (!this.conditions[this.name]) {
        this.$set(this.conditions, this.name, {
          predicate: this.predicate,
          values: ['']
        });
      }

      const result = this.values.split('\n').filter((v: any) => !!v);
      if (this.includeUnknown) {
        result.push('');
      }

      this.$set(this.conditions[this.name], 'values', result);
    } else {
      this.$set(this.conditions[this.name], 'values', ['']);
    }
  }
}
